<script>
import MetisMenu from 'metismenujs/dist/metismenujs'

import { authComputed } from '@state/helpers'
import {
  authProtectedRoutes,
  adminProtectedRoutes,
  privateProtectedRoutes,
  brokerProtectedRoutes,
  endUserProtectedRoutes,
  warehouseProtectedRoutes,
  financeireProtectedRoutes,
} from '@routes'
import { mapGetters } from 'vuex'

/**
 * Application menu component
 */
export default {
  components: {},
  filters: {
    renameMenu(menu) {
      let renamed = menu.replace('admin_', '')
      renamed = renamed.replace('_', '')
      return renamed
    },
  },
  props: {
    mode: {
      type: String,
      default: 'horizontal',
    },
  },
  data() {
    return {
      userRoutes: [...authProtectedRoutes],
      adminRoutes: [...adminProtectedRoutes],
      privateRoutes: [...privateProtectedRoutes],
      brokerRoutes: [...brokerProtectedRoutes],
      endUserRoutes: [...endUserProtectedRoutes],
      warehouseRoutes: [...warehouseProtectedRoutes],
      financeireRoutes: [...financeireProtectedRoutes],
      notifications: [],
      showPopup: false,
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('auth', [
      'isSubAccount',
      'isAdmin',
      'isPrivateCustomer',
      'isBroker',
      'isEndUser',
      'isWarehouse',
      'isFinanceire',
      'currentUser',
    ]),
    filteredUserRoutes() {
      return this.userRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
    filteredPrivateRoutes() {
      return this.privateRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
    filteredBrokerRoutes() {
      return this.brokerRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
    filteredEndUserRoutes() {
      return this.endUserRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
    filteredWarehouseRoutes() {
      return this.warehouseRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
    filteredFinanceireRoutes() {
      return this.financeireRoutes.filter((item) => {
        return (
          this.isSubAccount !== this.isParentRequired(item.meta) ||
          !this.isSubAccount
        )
      })
    },
  },
  watch: {
    notifications: function(newValue, oldValue) {
      if (this.notifications.length < 1) return false
      newValue.forEach((notification) => {
        this.$toastr.Add({
          title: notification.title,
          msg: notification.message,
          onCreated: () => {
            this.$store.dispatch(
              'notification/removeNotification',
              notification,
              { root: true }
            )
          },
          type: notification.type,
        })
      })
    },
  },
  created() {
    let _this = this
    this.$store.watch(
      function(state) {
        return state.notification.notifications
      },
      function() {
        _this.notifications =
          _this.$store.getters['notification/allNotifications']
      },
      { deep: true }
    )
  },
  mounted: function() {
    if (this.isBroker && this.currentUser.status === 'deactivate') {
      this.showPopup = true
    }
    this.notification = this.$store.getters['notification/allNotifications']
    // eslint-disable-next-line no-unused-vars
    var menuRef = null
    if (this.mode === 'horizontal') {
      menuRef = new MetisMenu('#side-menu').on('shown.metisMenu', function(
        event
      ) {
        window.addEventListener('click', function menuClick(e) {
          if (!event.target.contains(e.target)) {
            menuRef.hide(event.detail.shownElement)
            window.removeEventListener('click', menuClick)
          }
        })
      })
    } else {
      menuRef = new MetisMenu('#side-menu')
    }

    var links = document.getElementsByClassName('side-nav-link-ref')
    var matchingMenuItem = null
    // let menuItemEl = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    const activeClass = this.mode === 'horizontal' ? 'active' : 'mm-active'
    const dropdownActiveClass =
      this.mode === 'horizontal' ? 'active' : 'mm-show'
    if (matchingMenuItem) {
      if (matchingMenuItem) matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add(activeClass)
        const parent2 = parent.parentElement
        if (parent2) {
          parent2.classList.add(dropdownActiveClass)
        }
        const parent3 = parent2.parentElement
        if (parent3) {
          parent3.classList.add(activeClass)
          if (parent3.childNodes[1]) {
            parent3.childNodes[1].classList.add('active')
            parent3.childNodes[3].classList.add('mm-show')
          }
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }

        const parent4 = parent3.parentElement
        if (parent4) parent4.classList.add(dropdownActiveClass)
        const parent5 = parent4.parentElement
        if (parent5) parent5.classList.add(activeClass)
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item && item.children !== undefined
        ? item.children.length > 0 && item.meta.renderChildren === true
        : false
    },
    isInvalidMenu(item) {
      let hiddenMenus = ['Account', 'Billing']
      let invalid = false
      if (this.isSubAccount & hiddenMenus.includes(item.name)) {
        invalid = true
      }
      return invalid
    },
    isParentRequired(meta) {
      let required = false
      if (meta.hasOwnProperty('parentRequired')) {
        required = meta.parentRequired
      }
      return required
    },
    redirectToProfile() {
      this.$router.push(`/users/${this.currentUser.id}`)
    },
  },
}
</script>

<template>
  <ul v-if="isAdmin" id="side-menu" class="metismenu">
    <li
      v-for="item in adminRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <a
        v-if="hasItems(item)"
        href="javascript:void(0);"
        class="side-nav-link has-arrow"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name | renameMenu }}</span>
        <span class="menu-arrow"></span>
      </a>

      <router-link
        v-if="!hasItems(item) && !item.hidden"
        tag="a"
        :to="{ name: item.name }"
        class="side-nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name | renameMenu }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
      <ul v-if="hasItems(item)" class="nav-second-level" style="right: 100px">
        <li v-for="(subitem, index) in item.children" :key="index">
          <router-link
            v-if="!hasItems(subitem)"
            tag="a"
            :to="`${item.path}/${subitem.path}`"
            class="side-nav-link-ref"
            >{{ subitem.name }}</router-link
          >
        </li>
      </ul>
    </li>
  </ul>
  <ul v-else-if="isPrivateCustomer" id="side-menu" class="metismenu">
    <li
      v-for="item in filteredPrivateRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>

  <ul
    v-else-if="isBroker && currentUser.status === 'activate'"
    id="side-menu"
    class="metismenu"
  >
    <li
      v-for="item in filteredBrokerRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>
  <ul v-else-if="isBroker && currentUser.status === 'deactivate'">
    <b-modal
      v-if="$route.path !== `/users/${currentUser.id}`"
      v-model="showPopup"
      title="Account not activated"
      class="custom-modal"
      @ok="redirectToProfile"
    >
      <p class="font-size-17  "
        >Your account is not activated yet. Please verify the profile required
        and wait for admin approval. Thanks</p
      >
    </b-modal>
  </ul>

  <ul v-else-if="isEndUser" id="side-menu" class="metismenu">
    <li
      v-for="item in filteredEndUserRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.variant + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>

  <ul v-else-if="isWarehouse" id="side-menu" class="metismenu">
    <li
      v-for="item in filteredWarehouseRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>

  <ul v-else-if="isFinanceire" id="side-menu" class="metismenu">
    <li
      v-for="item in filteredFinanceireRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>

  <ul v-else id="side-menu" class="metismenu">
    <li
      v-for="item in filteredUserRoutes"
      :key="`item-${item.name}`"
      class="side-nav-title side-nav-item"
    >
      <p v-if="item.header" class="menu-title mb-0">{{ item.header }}</p>

      <router-link
        v-if="!item.hidden"
        tag="a"
        :to="`${item.path}`"
        class="nav-link side-nav-link-ref"
      >
        <i v-if="item.icon" :class="`uil ${item.icon}`" class="mr-2"></i>
        <span>{{ item.name }}</span>
        <span
          v-if="item.badge"
          :class="
            'badge badge-' + item.badge.varient + ' float-right font-size-11'
          "
          >{{ item.badge.text }}</span
        >
      </router-link>
    </li>
  </ul>

  <!-- End Sidebar -->
</template>
